import config from 'react-global-configuration';

export let APP_ENV = process.env.REACT_APP_ENV;
export const __DEBUG__ = APP_ENV !== 'production';
export const USE_SENTRY = process.env.REACT_APP_SENTRY_ENABLED;
export const SENTRY_DSN = process.env.REACT_APP_SENTRY_DSN;

export const IS_REACT_NATIVE = Boolean(window.ReactNativeWebView);

export let MULTILINGUAL = process.env.REACT_APP_MULTILINGUAL?.toLowerCase() === 'true';

export const DEFAULT_LANGUAGE = 'nl';
export const SITE_NAME = 'Jellinekzelfhulp';

export const IS_SERVER = !(
  typeof window !== 'undefined'
  && window.document
  && window.document.createElement
);
export const IS_CLIENT = !IS_SERVER;

export let API_URL = process.env.REACT_APP_API_URL || "http://zelfhulpalcohol.nl";

// Enable submission views
export let SUBMISSION_VIEW = process.env.REACT_APP_SUBMISSION_VIEW?.toLocaleLowerCase() !== 'false';

// HTI SSO.
export let HTI_SSO_ENABLED = process.env.REACT_APP_HTI_SSO_ENABLED?.toLocaleLowerCase() === 'true';
export let HTI_SSO_NAME = process.env.REACT_APP_HTI_SSO_NAME || 'GIDS anonieme ID';

// Enable theming.
export let ENABLE_THEMING = process.env.REACT_APP_ENABLE_THEMING?.toLocaleLowerCase() === 'true';

// Enable registration start date step on create recovery plan page.
// This is a temporary feature flag. Remove this when the feature is fully implemented.
export let ENABLE_REGISTRATIONS_START_DATE_STEP = process.env.REACT_APP_ENABLE_REGISTRATIONS_START_DATE_STEP?.toLocaleLowerCase() === 'true';

// Domains.
export const DOMAIN_JELLINEK_ZELFHULP = 'jellinekzelfhulp';
export const DOMAIN_ZELFHULP_ALCOHOL = 'zelfhulpalcohol';
export const DOMAIN_ZELFHULP_TABAK = 'zelfhulptabak';
export const DOMAIN_ZELFHULP_GOKKEN = 'zelfhulpgokken';
export const DOMAIN_ZELFHULP_CANNABIS = 'zelfhulpcannabis';
export const DOMAIN_ZELFHULP_COCAINE = 'zelfhulpcocaine';
export const DOMAIN_ZELFHULP_NAASTEN = 'zelfhulpnaasten';
export const DOMAIN_ZELFHULP_BEGELEID = 'zelfhulpbegeleid';

// Change this for what domain you want for dev.
export const DOMAIN_DEV = process.env.REACT_APP_DOMAIN_DEV || DOMAIN_ZELFHULP_ALCOHOL;

// Production urls.
export const URL_JELLINEK_ZELFHULP = 'https://www.jellinekzelfhulp.nl/';
export const URL_ZELFHULP_ALCOHOL = 'https://www.zelfhulpalcohol.nl/';
export const URL_ZELFHULP_TABAK = 'https://www.zelfhulptabak.nl/';
export const URL_ZELFHULP_GOKKEN = 'https://www.zelfhulpgokken.nl/';
export const URL_ZELFHULP_CANNABIS = 'https://www.zelfhulpcannabis.nl/';
export const URL_ZELFHULP_COCAINE = 'https://www.zelfhulpcocaine.nl/';
export const URL_ZELFHULP_NAASTEN = 'https://www.zelfhulpnaasten.nl/';
export const URL_ZELFHULP_BEGELEID = 'https://www.zelfhulpbegeleid.nl/';

// Vendor urls.
export const URL_JELLINEK = 'https://www.jellinek.nl/';
export const URL_ALLES_OVER_DRINKEN = 'https://allesoverdrinken.nl/';
export const URL_VERSLAVINGSKUNDE_NEDERLAND = 'https://www.verslavingskundenederland.nl/';
export const URL_JELLINEK_GOAL_PROS_CONS = 'https://www.jellinek.nl/vraag-antwoord/hoe-kan-ikzelf-minderen-of-stoppen-met-alcohol-of-drugs/';
export const MAILTO_STERKER_NAAST = 'mailto:sterkernaast@jellinek.nl';

// Route types.
export const ROUTE_TYPE_SELF_HELP = 'ROUTE_TYPE_SELF_HELP';
export const ROUTE_TYPE_GUIDED_SELF_HELP = 'ROUTE_TYPE_GUIDED_SELF_HELP';
export const ROUTE_TYPE_SELF_HELP_CLOSE_ONES = 'ROUTE_TYPE_SELF_HELP_CLOSE_ONES';

// Route search params.
export const ROUTE_LOGIN_SEARCH_PARAM = 'logged_in=true';

// The value is where the breakpoint starts (mobile-first).
// These values are taken from '/src/src/styles/assets/_variables.scss'.
export const SCREEN_MOBILE = 0;
export const SCREEN_TABLET = 768;
export const SCREEN_NORMAL = 992;
export const SCREEN_WIDE = 1240;
export const SCREEN_HUGE = 2000;

// custom constants
export const MINIMUM_PASSWORD_CHARACTER_COUNT = 7;
export const PAIRING_CODE_LENGTH = 6;

// Use config to share static configuration between components and packages.
config.set({
  'SITE_NAME': SITE_NAME,
  'MULTILINGUAL': MULTILINGUAL,
  'DEFAULT_LANGUAGE': DEFAULT_LANGUAGE,
  'API_URL': API_URL,
  // Set freeze to false to allow overwriting the configs based on the
  // options passed to window.reactFrontend
}, { freeze: false });

// Aria disclosure IDs.
export const ARIA_DISCLOSURE_ID_ACCOUNT_MENU = 'ARIA_DISCLOSURE_ID_ACCOUNT_MENU';
export const ARIA_DISCLOSURE_ID_KEBAB = 'ARIA_DISCLOSURE_ID_KEBAB';

// Main menu item types.
export const MENU_ITEM_TYPE_ACCOUNT = 'account';
export const MENU_ITEM_TYPE_LOGOUT = 'user.logout';

// Onboarding subpages.
export const ONBOARDING_PAGE_CHECKLIST = 'checklist';
export const ONBOARDING_PAGE_CREDENTIALS = 'credentials';
export const ONBOARDING_NODE_TYPE = 'onboarding';

// Joyride page
export const JOYRIDE_NODE_TYPE = 'joyride';

// Message templates.
export const MESSAGE_TEMPLATE_BADGE = 'received_badge';

// Crisis alerts.
export const COOKIE_HIDDEN_CRISIS_ALERTS = 'cookie-hidden-crisis-alerts';

// Daily registrations.
export const DAYS_IN_WEEK = 7;
export const PROGRAM_DURATION_WEEKS = 6;
export const PROGRAM_DURATION_DAYS = PROGRAM_DURATION_WEEKS * DAYS_IN_WEEK;
export const DEFAULT_MAXIMUM_REGISTRATION_AMOUNT = 10;
export const USAGE_STEP_INCREMENT = 0.5;
export const ZELFHULP_GOKKEN_USAGE_STEP_INCREMENT = 0.25;
export const ZELFHULP_GOKKEN_MAX_USAGE = 24;
export const ZELFHULP_ALCOHOL_USAGE_WARNING_THRESHOLD = 15;

// Forum.
export const FORUM_COMMENT_ID_PREFIX = 'comment-';

// Nurse practitioner info field for webforms (exercises).
// We use this system name for fields hidden to the client, but shown to a nurse practitioner as extra info.
export const WEBFORM_FIELD_NURSE_PRACTITIONER_INFO = 'nurse_practitioner_info';

// Webform ID for some static exercises.
export const WEBFORM_ID_GOAL = 'goal';

// Webform ID for support form.
export const WEBFORM_ID_SUPPORT = 'contact_form';

export const WEBFORM_CATEGORIES_ASSIGNMENTS = ['text', 'list', 'quiz', 'video'];

// Tooltip
export const TOOLTIP_MARGIN_THRESHOLD = 10;

// User roles.
export const USER_ROLES = {
  CLIENT: 'client',
  SSO_CLIENT: 'sso_client',
  POH: 'poh',
};

// Languages.
export let LANGUAGES = {
  nl: 'Nederlands',
};

export const COOKIE_LANGUAGE_PREFERENCE = 'cookie-language-preference';

export const MAIN_CONTENT_ID = 'main-content';

// Program page scroll
export const SCROLL_OFFSET_AVAILABLE_EXERCISE = 150;
export const SCROLL_OFFSET_LOCKED_EXERCISE = 270;
export const SCROLL_OFFSET_EXERCISE_EXTRA_MOBILE = 240;

// Scroll position threshold for keeping track of the scroll direction.
export const SCROLL_POSITION_THRESHOLD = 250;

export function saveConstants(options) {
  if (options.parameters.env) {
    APP_ENV = options.parameters.env;
  }

  if (options.apiUrl) {
    API_URL = options.apiUrl;
  }

  if (options.parameters.htiSsoEnabled) {
    HTI_SSO_ENABLED = options.parameters.htiSsoEnabled;
  }

  if (options.parameters.htiSsoName) {
    HTI_SSO_NAME = options.parameters.htiSsoName;
  }

  if (options.parameters.multilingualEnabled) {
    MULTILINGUAL = true;
  }

  if (options.parameters.submissionView === false) {
    SUBMISSION_VIEW = false;
  }

  if (options.parameters.availableLanguages) {
    LANGUAGES = options.parameters.availableLanguages;
  }

  if (options.parameters.enableTheming) {
    ENABLE_THEMING = options.parameters.enableTheming;
  }

  if (options.parameters.enableRegistrationsStartDateStep) {
    ENABLE_REGISTRATIONS_START_DATE_STEP = options.parameters.enableRegistrationsStartDateStep;
  }

  if (APP_ENV === 'development') {
    // Use proxy in dev to prevent CORS issues.
    API_URL = 'http://localhost:3000/api';
  }

  // Update the config.
  config.set({
    'SITE_NAME': SITE_NAME,
    'MULTILINGUAL': MULTILINGUAL,
    'DEFAULT_LANGUAGE': DEFAULT_LANGUAGE,
    'API_URL': API_URL,
    'SUBMISSION_VIEW': SUBMISSION_VIEW,
    'ENABLE_THEMING': ENABLE_THEMING,
    'ENABLE_REGISTRATIONS_START_DATE_STEP': ENABLE_REGISTRATIONS_START_DATE_STEP,
  });
}
